import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";  
import "primereact/resources/primereact.min.css";
import "./assets/scss/custom.scss"
import "../node_modules/@fortawesome/fontawesome-pro/css/all.min.css"
import "./_config/i18n";
import { Provider } from "react-redux";
import Store from "./_stores/index";
import {  addLocale} from 'primereact/api';

const root = ReactDOM.createRoot(document.getElementById("root"));

addLocale('tr', {
  firstDayOfWeek: 1,
  closeText: 'kapat',
  prevText: 'geri',
  nextText: 'ileri',
  currentText: 'bugün',
  monthNames: ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'],
  monthNamesShort: ['Oca','Şub','Mar','Nis','May','Haz', 'Tem','Ağu','Eyl','Eki','Kas','Ara'],
  dayNames: ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'],
  dayNamesShort: ['Pz','Pt','Sa','Ça','Pe','Cu','Ct'],
  dayNamesMin: ['Pz','Pt','Sa','Ça','Pe','Cu','Ct'],
  weekHeader: 'Hf',
  firstDay: 1,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: '',
  timeOnlyTitle: 'Zaman Seçiniz',
  timeText: 'Zaman',
  hourText: 'Saat',
  minuteText: 'Dakika',
  secondText: 'Saniye',
  ampm: false,
  month: 'Ay',
  week: 'Hafta',
  day: 'Gün',    
});
root.render(
  <Provider store={Store}>
 
    <Router>
      <App />
    </Router>
    </Provider>
);
